export default "__VITE_ASSET__ebc54690__"